import { useEmbeddedAuth } from '@src/contexts/embedded-auth/useEmbeddedAuth';
import { useGetUser } from './useUser';

export function useEnabled(enabled: boolean = true) {
  const { isAuthenticated } = useEmbeddedAuth();
  const { data: user } = useGetUser(isAuthenticated);
  const termsAndConditionsAcceptedAt =
    user?.metadata?.termsAndConditionsAcceptedAt;
  const isEnabled = !!termsAndConditionsAcceptedAt && enabled;
  return isEnabled;
}
